import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["templates", "form", "templateId", "blankInput", "templateLabel"]
  static values = { autoOpen: Boolean }

  connect() {
    this.updateSelectedCard(this.templateIdTarget.value)
    if (this.autoOpenValue) this.openForm()
  }

  showForm(event) {
    event.preventDefault()
    const button = event.currentTarget
    const template = button.dataset.template
    const templateName = button.dataset.templateName || "Blank board"

    if (template === "blank") {
      this.blankInputTarget.value = "true"
      this.templateIdTarget.value = ""
      if (this.hasTemplateLabelTarget) this.templateLabelTarget.textContent = "Blank board"
    } else {
      this.blankInputTarget.value = ""
      this.templateIdTarget.value = template
      if (this.hasTemplateLabelTarget) this.templateLabelTarget.textContent = templateName
    }

    this.updateSelectedCard(this.templateIdTarget.value)
    this.openForm()

    const nameInput = this.formTarget.querySelector("input[type='text']")
    if (nameInput) {
      nameInput.value = template === "blank" ? "" : `${templateName} Board`
      window.setTimeout(() => nameInput.focus(), 100)
    }

    const textarea = this.formTarget.querySelector("textarea")
    if (textarea) textarea.value = ""
  }

  openForm() {
    this.templatesTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
  }

  hideForm() {
    this.templatesTarget.classList.remove("hidden")
    this.formTarget.classList.add("hidden")

    const form = this.formTarget.querySelector("form")
    if (form) form.reset()
    this.updateSelectedCard(this.templateIdTarget.value)
  }

  updateSelectedCard(templateId) {
    this.element.querySelectorAll("[data-template]").forEach((card) => {
      const selected = card.dataset.template === (templateId || "blank")
      card.setAttribute("aria-pressed", String(selected))
      card.classList.toggle("ring-2", selected)
      card.classList.toggle("ring-purple-500", selected)
      card.classList.toggle("border-purple-500", selected)
    })
  }
}
